import React from "react";
import FeedbackForm from "../../components/feedbackFrom/FeedbackForm";
import { Box } from "@mui/material";

const UserFeedback = () => (
  <Box
    sx={{
      width: "100%",
      minHeight: "100vh",
      backgroundColor: "#fff",
      py: 4,
      px: { xs: 2, sm: 3, md: 4 },
    }}
  >
    <FeedbackForm />
  </Box>
);

export default UserFeedback;
